import { ADD_DATA_SOURCES, CLEAR_DATA_SOURCES, SET_DS_FETCHING } from "../actions/types";

const initialState = { status: "notFetched", dataSources: [] };

//Handling Datasources
export const dataSourceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DS_FETCHING:
      return { ...state, status: "fetching" };
    case ADD_DATA_SOURCES:
      return { ...state, status: "done", dataSources: payload };
    case CLEAR_DATA_SOURCES:
      return initialState;
    default:
      return state;
  }
};
